.placeholder {
  position: relative;
  display: grid;
  row-gap: var(--mantine-spacing-xs);
  place-content: center;
  padding: var(--mantine-spacing-md);
  font-size: var(--mantine-font-size-sm);
  font-weight: var(--mantine-heading-font-weight);
  line-height: 1;
  color: var(--mantine-color-dark-2);
  text-align: center;
  text-transform: uppercase;
  background: linear-gradient(
    to bottom,
    light-dark(alpha(var(--mantine-color-dark-5), 0.075), alpha(var(--mantine-color-dark-5), 0.3)),
    light-dark(alpha(var(--mantine-color-dark-5), 0.025), alpha(var(--mantine-color-dark-5), 0.1))
  );
  border-radius: var(--mantine-radius-sm);
  &::before {
    font-size: calc(var(--mantine-font-size-md) * 0.5);
    font-weight: normal;
    color: var(--mantine-color-dark-4);
    content: 'Placeholder #' counter(chart);
  }
  &::after {
    position: absolute;
    top: 50%;
    left: var(--mantine-spacing-xs);
    font-size: var(--mantine-font-size-xl);
    font-weight: normal;
    translate: 0 -50%;
  }
}
